import { render } from "./Layout4.vue?vue&type=template&id=3aa825d3&ts=true"
import script from "./Layout4.vue?vue&type=script&lang=ts"
export * from "./Layout4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__